import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'navigation_history';

const hasSessionStorage = typeof window !== 'undefined' && typeof sessionStorage !== 'undefined';

let historyStack = (() => {
    if (!hasSessionStorage) {
        return [];
    }
    try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
        return [];
    }
})();

function save() {
    if (!hasSessionStorage) {
        return;
    }
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(historyStack));
    } catch {
        // ignore storage errors
    }
}

export function popHistory() {
    historyStack.pop();
    save();
}

export function getPreviousUrl(currentPath) {
    if (historyStack.length === 0) {
        return undefined;
    }

    const top = historyStack[historyStack.length - 1];
    if (currentPath && top !== currentPath) {
        return top;
    }

    return historyStack[historyStack.length - 2];
}

export function clearNavigationHistory() {
    historyStack = [];

    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore storage errors
    }
}

export function useNavigationHistory() {
    const location = useLocation();

    useLayoutEffect(() => {
        const path = location.pathname + location.search;

        if (historyStack[historyStack.length - 1] !== path) {
            if (historyStack.length > 50) {
                historyStack.shift();
            }
            historyStack.push(path);
            save();
        }
    }, [location]);

    return historyStack;
}
